@if (validationResult.errors.length > 0) {
    <div class="flex items-center mb-2">
        <img class="mr-2" src="assets/svg/error_icon.svg" alt="Error Icon" />
        <div class="flex flex-col">
            @for (error of validationResult.errors; track error.propertyName) {
                <p class="!m-0 text-tertiary-900 font-medium">
                    {{ error.errorMessage }}
                </p>
            }
        </div>
    </div>
}
